import { EntityChanged } from '@dynamik/common/clients/notification-clients';

export class EntityChangedTyped<T extends { init(data: any): void }> extends EntityChanged {
  override data: T;
}
